import React from 'react';
import { Dashboard } from './components';
import PrivateRoute from 'PrivateRoutes';
import { Route } from 'react-router';

// const routes = () => <Route exact path="/dashboard" component={Dashboard} />;
const routes = () => [
    <PrivateRoute exact path="/dashboard" key="dashboardHome" component={Dashboard} />,
    <PrivateRoute exact path="/" key="dashboard" component={Dashboard} />,
];
// const routes = () => [
//   <PrivateRoute
//     key="dashboard"
//     exact
//     path="/dashboard"
//     component={Dashboard}
//   />,
//   <PrivateRoute key="dashboard-main" path="/" component={Dashboard} />
// ];

export default routes;



// WEBPACK FOOTER //
// ./src/modules/screens/dashboard/Dashboard/routes.js